import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, Group, Text } from '@mantine/core';

import type { OrganisationType } from 'types';

import { NameSettingsModal } from './NameSettingsModal';

type Props = {
  organisation: OrganisationType;
};

export const NameSettings = ({ organisation }: Props) => {
  const { name, isAdministrator } = organisation;
  const [modalOpened, setModalOpened] = useState(false);

  const { t } = useTranslation('organisations');

  return (
    <Box>
      <Text
        sx={theme => ({
          fontSize: 15,
          fontWeight: 'bold',
          marginBottom: theme.other.spacing(1),
        })}
      >
        {t('organisationView.details.profile.name.title')}
      </Text>
      <Text
        sx={theme => ({
          fontSize: 13,
          color: theme.colors.gray[6],
          marginBottom: theme.other.spacing(2),
        })}
      >
        {isAdministrator
          ? t('organisationView.details.profile.name.description.default')
          : t('organisationView.details.profile.name.description.adminOnly')}
      </Text>
      <Group spacing="lg">
        <Text>{name}</Text>
        {isAdministrator && (
          <Button variant="default" onClick={() => setModalOpened(true)}>
            {t('organisationView.details.profile.name.editButton')}
          </Button>
        )}
      </Group>
      <NameSettingsModal
        opened={modalOpened}
        onClose={() => setModalOpened(false)}
        organisation={organisation}
      />
    </Box>
  );
};
